var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { COLORS } from "../../../constants";
import { keyframes } from "@emotion/react";
var loadingAnimation = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: .4;\n  }\n\n  100% {\n    opacity: 1;\n  }\n"], ["\n  0% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: .4;\n  }\n\n  100% {\n    opacity: 1;\n  }\n"])));
var LoadingSkeleton = function (_a) {
    var _b = _a.sx, sx = _b === void 0 ? {} : _b;
    return (_jsx(Box, __assign({ "data-testid": "loading-skeleton", component: "span", sx: __assign({ display: "inline-flex", width: "100%", backgroundColor: COLORS.P_OUTLINE, animation: "".concat(loadingAnimation, " 1.5s infinite"), animationTimingFunction: "cubic-bezier(.42,0,.58,1)", borderRadius: 2 }, sx) }, { children: _jsx("br", {}) })));
};
export default LoadingSkeleton;
var templateObject_1;
